import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHF,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormNumberFieldWithLabel,
} from "@websential/cosmic-v20";

import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";

interface ITD1ReportHeader {
	TD1ReporEmployeeDDlItems?: { label: string; value: any }[];
	setStateRunGetListAPICall: (value: boolean) => void
}

export const TD1ReportHeader: React.FC<
	ITD1ReportHeader
> = ({ TD1ReporEmployeeDDlItems, setStateRunGetListAPICall }) => {
	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderBottom: 0,
					borderRadius: "2px 2px 0 0",
					padding: "31px 20px 2.5rem 20px",
					marginBottom: "0px!important",
					fontSize: "0.875rem",
				}} columnSpacing={2}>
				<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
					sx={{
						fontSize: "0.875rem",
						color: "#4b5563",
						"& .dropDownWrapper": { marginBottom: "15px!important" },
					}}>
					<EnhancedDropDownRHFWithLabel
						selectName="employee"
						testId={`employee`}
						items={TD1ReporEmployeeDDlItems ?? []}
						selectedItem={"all"}
						label="Employee"
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
					/>
					<EnhancedDropDownRHFWithLabel
						selectName="provinceFederal"
						testId="province-federal-td1"
						items={[
							{ value: "all", label: "All" },
							{ value: "federal", label: "Federal" },
							{ value: "ontario", label: "Ontario" },
							{ value: "alberta", label: "Alberta" },
							{ value: "britishColumbia", label: "British Columbia" },
							{ value: "manitoba", label: "Manitoba" },
							{ value: "newBrunswick", label: "New Brunswick" },
							{ value: "newfoundlandAndLabrador", label: "Newfoundland and Labrador" },
							{ value: "novaScotia", label: "Nova Scotia" },
							{ value: "northwestTerritories", label: "Northwest Territories" },
							{ value: "nunavut", label: "Nunavut" },
							{ value: "princeEdwardIsland", label: "Prince Edward Island" },
							{ value: "quebec", label: "Quebec" },
							{ value: "saskatchewan", label: "Saskatchewan" },
							{ value: "yukon", label: "Yukon" },
						]}
						selectedItem={"all"}
						label="Province / Federal"
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
					/>
					<EnhancedButtonPrimeReact
						label="Apply Filter"
						raised
						type="submit"
						// onClickHandler={onApplyButtonClickedHandler}
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
					/>

				</Grid>
			</Grid>
		</>
	);
};
